// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-admin {
  width: min(96vw, 760px);
  max-height: 84vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.analytics-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.analytics-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.analytics-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.analytics-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.analytics-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.analytics-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.analytics-admin__body::-webkit-scrollbar {
  width: 8px;
}

.analytics-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
}

.analytics-admin__hint {
  margin: 0 0 0.9rem;
  font-size: 0.85rem;
  color: #9fb4cc;
}

.analytics-admin__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.analytics-admin__range {
  display: flex;
  gap: 0.35rem;
}

.analytics-admin__range-btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid transparent;
  color: #c2cede;
  font-size: 0.8rem;
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.analytics-admin__range-btn:hover:not(:disabled) {
  background: #23384f;
  color: #fff;
}

.analytics-admin__range-btn.active {
  border-color: #4a9eff;
  color: #fff;
  background: rgba(74, 158, 255, 0.18);
}

.analytics-admin__range-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.analytics-admin__error {
  color: #ff9d9d;
  background: rgba(255, 80, 80, 0.1);
  border: 1px solid rgba(255, 80, 80, 0.3);
  border-radius: 6px;
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.8rem;
  font-size: 0.85rem;
}

.analytics-admin__status {
  color: #9fb4cc;
  font-size: 0.9rem;
  padding: 0.8rem 0;
}

.analytics-admin__cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.6rem;
  margin-bottom: 1.1rem;
}

.analytics-admin__card {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.7rem 0.85rem;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(74, 158, 255, 0.15);
}

.analytics-admin__card--accent {
  border-color: rgba(74, 158, 255, 0.5);
  background: rgba(74, 158, 255, 0.12);
}

.analytics-admin__card-value {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.1;
}

.analytics-admin__card-label {
  color: #9fb4cc;
  font-size: 0.78rem;
}

.analytics-admin__table-wrap {
  overflow-x: auto;
}

.analytics-admin__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.analytics-admin__table th,
.analytics-admin__table td {
  text-align: left;
  padding: 0.5rem 0.6rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.15);
  vertical-align: top;
}

.analytics-admin__table th {
  color: #9fb4cc;
  font-weight: 600;
  white-space: nowrap;
}

.analytics-admin__num {
  text-align: right;
}

.analytics-admin__step {
  display: block;
  color: #fff;
}

.analytics-admin__raw {
  display: block;
  color: #7d90a8;
  font-size: 0.72rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/analytics-admin-panel/analytics-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,gCAAgC,aAAa,EAAE,cAAc,EAAE;;AAE/D;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".analytics-admin {\r\n  width: min(96vw, 760px);\r\n  max-height: 84vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.analytics-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.analytics-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.analytics-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.analytics-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.analytics-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.analytics-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.analytics-admin__body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.analytics-admin__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.25);\r\n  border-radius: 4px;\r\n}\r\n\r\n.analytics-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 0.85rem;\r\n  color: #9fb4cc;\r\n}\r\n\r\n.analytics-admin__toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.analytics-admin__range {\r\n  display: flex;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.analytics-admin__range-btn {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border: 1px solid transparent;\r\n  color: #c2cede;\r\n  font-size: 0.8rem;\r\n  padding: 0.3rem 0.65rem;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.analytics-admin__range-btn:hover:not(:disabled) {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.analytics-admin__range-btn.active {\r\n  border-color: #4a9eff;\r\n  color: #fff;\r\n  background: rgba(74, 158, 255, 0.18);\r\n}\r\n\r\n.analytics-admin__range-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n.analytics-admin__error {\r\n  color: #ff9d9d;\r\n  background: rgba(255, 80, 80, 0.1);\r\n  border: 1px solid rgba(255, 80, 80, 0.3);\r\n  border-radius: 6px;\r\n  padding: 0.6rem 0.8rem;\r\n  margin-bottom: 0.8rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.analytics-admin__status {\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n  padding: 0.8rem 0;\r\n}\r\n\r\n.analytics-admin__cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 0.6rem;\r\n  margin-bottom: 1.1rem;\r\n}\r\n\r\n.analytics-admin__card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.2rem;\r\n  padding: 0.7rem 0.85rem;\r\n  border-radius: 8px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border: 1px solid rgba(74, 158, 255, 0.15);\r\n}\r\n\r\n.analytics-admin__card--accent {\r\n  border-color: rgba(74, 158, 255, 0.5);\r\n  background: rgba(74, 158, 255, 0.12);\r\n}\r\n\r\n.analytics-admin__card-value {\r\n  color: #fff;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  line-height: 1.1;\r\n}\r\n\r\n.analytics-admin__card-label {\r\n  color: #9fb4cc;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.analytics-admin__table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.analytics-admin__table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.analytics-admin__table th,\r\n.analytics-admin__table td {\r\n  text-align: left;\r\n  padding: 0.5rem 0.6rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.15);\r\n  vertical-align: top;\r\n}\r\n\r\n.analytics-admin__table th {\r\n  color: #9fb4cc;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.analytics-admin__num {\r\n  text-align: right;\r\n}\r\n\r\n.analytics-admin__step {\r\n  display: block;\r\n  color: #fff;\r\n}\r\n\r\n.analytics-admin__raw {\r\n  display: block;\r\n  color: #7d90a8;\r\n  font-size: 0.72rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
